<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">GPS端末情報編集</h1>
              <div class="field">
                <label class="label">UID</label>
                <div class="control">
                  <input class="input" type="text" v-model="inputForm.uid" disabled>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">名称</label>
                    <div class="control">
                      <input class="input" type="text" placeholder="名称" v-model="inputForm.disp_name">
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">軌跡表示色</label>
                    <chrome-picker v-model="inputForm.color"></chrome-picker>
                  </div>
                </div>
              </div>
              <button class="button is-link" v-on:click="update">確　定</button>
              &nbsp;&nbsp;
              <button v-if="inputForm.activate_flag === '1'" class="button is-danger" v-on:click="disable">無効にする</button>
              <button v-else class="button is-primary" v-on:click="enable">有効にする</button>
              &nbsp;&nbsp;
              <router-link to="/settings/device">
                <span class="button is-primary">
                  <span class="icon"><i class="fa fa-backward"></i></span>&nbsp;&nbsp;戻　る
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Compact } from 'vue-color'

export default {
  data: function(){
    return {
      showModal: false,
      inputForm: {
        uid: 0,
        disp_name: '',
        color: '#194d33',
        activate_flag: false,
      },
    }
  },
  computed:{
    ...mapGetters({
      getDevice: 'item/getDevice'
    }),
    ...mapState({
      apiStatus: state => state.item.apiStatus,
    })
  },
  mounted (){
    this.$set(this, 'inputForm', this.getDevice(this.$route.params.deviceId))
  },
  components: {
    'chrome-picker': Compact,
  },
  methods: {
    async update () {
      if(this.inputForm.disp_name ===""){
        this.$swal({
          title: '確認',
          text: '名称を入力してください。',
          icon: 'error',
          confirmButtonText: '戻る',
        })
        return false
      }
      this.$set(this.inputForm, 'color', this.inputForm.color.hex ?  this.inputForm.color.hex : this.inputForm.color)
      await this.$store.dispatch('item/updateDevice', this.inputForm)
      if(this.apiStatus){
        this.$swal({
          position: 'top-end',
          icon: 'success',
          title: 'データを更新しました。',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    disable() {
      this.$set(this.inputForm, 'activate_flag', '0')
      this.update()
    },
    enable() {
      this.$set(this.inputForm, 'activate_flag', '1')
      this.update()
    }
  }
}
</script>